module.exports = __webpack_public_path__ + "img/router.fc286566.gif";